import { Menu, useColorModeValue } from '@chakra-ui/react';
import { FilterHeading } from 'src/components/atoms/FilterHeading';
import { MenuButton } from 'src/components/atoms/MenuButton';
import { MenuOpenerButton } from 'src/components/atoms/MenuOpenerButton';
import { MenuOption } from 'src/components/atoms/MenuOption';
import { MenuList } from 'src/components/molecules/MenuList';
import { useAggregationLevelContext } from 'src/features/MM/contexts/AggregationLevelContext';
import { getAggregationName } from 'src/features/MM/utils/getAggregationName';
import { AggregateLevel } from 'src/types';
import { Icon } from 'src/components/atoms/Icon';
import { MenuTriangle } from 'src/components/atoms/MenuTriangle';

const aggregateOptions: Array<AggregateLevel> = [
  AggregateLevel.week,
  AggregateLevel.month,
  AggregateLevel.quarter,
  AggregateLevel.biannual,
  AggregateLevel.year,
];

const MENU_BUTTON_NAME = 'aggregate-select';

const AggregationMenu: React.FC = () => {
  const { aggregateLevel, setAggregateLevel } = useAggregationLevelContext();
  const fontActiveColor = useColorModeValue(
    'text.darkBlue.900',
    'text.dark.highContrast',
  );
  return (
    <Menu isLazy>
      {({ isOpen }) => (
        <>
          <MenuButton buttonName={MENU_BUTTON_NAME} color={fontActiveColor}>
            <Icon iconName="database" width={6} height={6} mr={2} />
            {getAggregationName(aggregateLevel)}
            <MenuTriangle isOpen={isOpen} />
          </MenuButton>
          <MenuList buttonName={MENU_BUTTON_NAME}>
            {aggregateOptions.map((aggLevel) => (
              <MenuOption
                buttonName={MENU_BUTTON_NAME}
                colorSelected
                key={aggLevel}
                value={aggLevel}
                label={getAggregationName(aggLevel)}
                isSelected={aggregateLevel === aggLevel}
                onClick={() => setAggregateLevel(aggLevel)}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  );
};
export const AggregationSelector: React.FC = () => {
  return (
    <>
      <FilterHeading headingText="Aggregation" color="text.darkGray" />
      <MenuOpenerButton>
        <AggregationMenu />
      </MenuOpenerButton>
    </>
  );
};
